import * as angular from 'angular';
import { config } from 'angular/utils/config';

export interface CapacityCategoryResource extends ng.resource.IResourceClass<
    ng.resource.IResource<CapacityCategory[]>
> {
    get: ng.resource.IResourceMethod<ng.resource.IResource<CapacityCategory[]>>;
}

function capacityCategoryResource(
    $resource: ng.resource.IResourceService
): CapacityCategoryResource {
    return <CapacityCategoryResource>$resource(
        config.monolithApi + '/capacity-category',
        {},
        {
            get: {
                method: 'GET',
                url: config.monolithApi + '/capacity-category',
                isArray: true
            }
        }
    );
}

angular
    .module('app')
    .factory('capacityCategoryResource', capacityCategoryResource);
